module.exports = __webpack_public_path__ + "img/icon-facebook.4fb63cd7.svg";